<template>
  <div>
    <v-row>
      <v-col>
        <v-card>
          <v-tabs v-model="tab" background-color="transparent">
            <v-tab>Profile</v-tab>
            <v-tab>Notes</v-tab>
            <v-tab>Proposals</v-tab>
            <v-tab>Subscriptions</v-tab>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>

    <div>
      <v-tabs-items v-model="tab" style="background-color:transparent">
        <v-tab-item>
          <ClientProfile />
        </v-tab-item>
        <v-tab-item>
          <ClientNotes />
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>Proposals</v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>Subscriptions</v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import ClientProfile from "@/components/client/ClientProfile";
import ClientNotes from "@/components/client/ClientNotes";
import store from "@/store";

export default {
  name: "clientdetail",
  components: {
    ClientProfile,
    ClientNotes
  },
  data() {
    return {
      tab: null
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch("loadCurrentClient", routeTo.params.id).then(() => {
        next();
      });
    }
  }
};
</script>

<style></style>
